import axios, { AxiosRequestConfig } from "axios";

export const getDashboardData = async (
  token: string,
  id_empresa: number | null
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/dashboard`;

    const response = await axios.post(url, {id_empresa: id_empresa}, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar dados do dashboard:", error);
    throw error;
  }
};

export const getEmpresasData = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/getEmpresa`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar empresas:", error);
    throw error;
  }
};

export const getEmpresaLocais = async (token: string, idVeiculo: number) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
      params: {
        id_veiculo: idVeiculo,
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/getEmpresasLocais`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar empresas e locais:", error);
    throw error;
  }
};



